import { FAQService } from './../../core/services/FAQ/FAQ.service';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { serverError } from './../../core/models/messages';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-faq-esn',
  templateUrl: './faq-esn.component.html',
  styleUrls: ['./faq-esn.component.css'],
})
export class FaqEsnComponent {
  parentItem = 'Oups, Aucune donnée disponible pour le moment.';
  /* pagination */
  totalItems: number = 10;
  startIndex: number = 0;
  endIndex: number = 10;
  offset: number = 0;
  listFaq: any;
  loadSpinner: boolean = false;
  loadSpinnerTable: boolean = false;
  pagination : boolean =false;

  listtuto: any;
  ispagination: boolean = true;
  
  startSearching:boolean = false;

  currentPage: number = 0;
  pageSize = 5;
  pageSizeOptions = [5, 10, 20];

  constructor(
    private toastrService: ToastrService,
    private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    private faqService: FAQService
  ) {}
  private unsubscribeAll: Subject<void> = new Subject();
  ngOnInit() {
    this.getListFaq();
  }
  getListFaq() {
    this.spinner.show();
    this.loadSpinnerTable = true;

    // let dataPyload = {perpage: this.itemsPerPage, page: this.currentPage}
    this.faqService
      .getAllFaqESN(this.pageSize, this.currentPage + 1)
      .subscribe({
        next: (res) => {
          if (res.status === 200) {
            const responseData: any = res.data.data;

            this.listFaq = res.data.data
            // .slice(0, this.endIndex);
            // this.totalItems = responseData.length;
            this.totalItems = res.data.total;
          }
          this.spinner.hide();
          this.loadSpinnerTable = false;
        },
        error: (err: Error) => {
          this.toastrService.error(serverError);
          this.spinner.hide();
          this.loadSpinnerTable = false;
        },
      });
  }

  reset() {
    this.currentPage = 0;
    this.startSearching = false;
    this.searchFormGroup.reset();
    this.searchFormGroup = this.createSearchForm();
    this.getListFaq();
  }

  searchFormGroup: FormGroup = this.createSearchForm();
  createSearchForm(data?: any) {
    return this.formBuilder.group({
      search: [null, data?.search],
      type: ['', data?.type],
    });
  }

  applyFilter(pageNumber : number = this.currentPage) {
    let data = {
      type: 2,
      search: this.searchFormGroup.value.search,
      page: pageNumber + 1,
      per_page: this.pageSize,
    };
    this.spinner.show();
    this.faqService
      .searchfaq(data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
            this.listFaq = res.data.data
            this.totalItems = res.data.total;
            this.ispagination = true;
            this.spinner.hide();
        },
        error: () => {
          this.toastrService.error(serverError);
          this.spinner.hide();
        },
      });
  }
  noResults() {
    this.spinner.hide();
    this.listFaq = [];
  }

  onPageChange(e: PageEvent): void {
    this.pageSize = e.pageSize;
    this.currentPage = e.pageIndex;
    if (this.startSearching) {
      this.applyFilter();
    } 
    else {
      this.getListFaq();
    }
  }

}
